import { PropsWithChildren, useContext, useMemo } from 'react'

import { ContentType, LucideIconName } from '@bm-js/atlascloud-shared'
import { useEditorActions } from '../../utils/hooks'
import { DragNDropContext } from '../../contexts/DragNDrop.context'
import { useDebouncedBoolean } from '../../hooks/useDebounce'
import { EDITOR_DRAG_AND_DROP_TIMEOUT } from '../../cnst/editor.cnst'
import { Icon } from '@bm-js/atlascloud-ui'

type Props = {
  content: ContentType<unknown>
}

const DynamicContentWrapper = ({
  children,
  content,
}: PropsWithChildren<Props>) => {
  const { setActiveContent } = useEditorActions()
  const {
    state: { currentDraggingContent },
  } = useContext(DragNDropContext)

  const isDragging = useMemo(() => {
    return currentDraggingContent?.uuid === content.uuid
  }, [currentDraggingContent, content.uuid])

  const hideContent = useDebouncedBoolean(
    isDragging,
    EDITOR_DRAG_AND_DROP_TIMEOUT
  )

  return (
    <div
      className={`relative group/inner ${hideContent ? 'transition-all h-0 overflow-hidden' : ''}`}
      onClick={() => setActiveContent(content.uuid)}
    >
      {children}
      <div className='absolute inset-0 bg-primary-300/10 pointer-events-none opacity-0 group-hover/inner:opacity-100 rounded-lg'>
        <div className='absolute top-0 left-0 opacity-1000 group-hover/inner:opacity-100 flex justify-center w-full'>
          <div className='bg-primary-400 p-1 rounded text-white'>
            <Icon name={LucideIconName.Hand} className='size-5' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DynamicContentWrapper
